<template>
	<div class="py-6">
		<p v-if="total > 0">
			{{ showingLabel }} {{ start }} {{ toLabel }} {{ end }} {{ ofLabel }} {{ total }}
			{{ resultsLabel }}.
		</p>
	</div>
</template>

<script>
import Base from "../base.js"
import EventBus from "../../../../bus"
import Events from "../../../news-listing/events"

export default {
	name: "IntOverview",

	mixins: [Base],

	props: {
		initialPageNumber: { type: Number, default: 1 },
		initialPageSize: { type: Number, default: 12 },
		initialTotal: { type: Number, default: 0 },
		shouldDisplay: { type: Boolean, default: true },
		showingLabel: { type: String, default: "Showing" },
		toLabel: { type: String, default: "to" },
		ofLabel: { type: String, default: "of" },
		resultsLabel: { type: String, default: "products" },
	},

	data() {
		return {
			start: (this.initialPageNumber - 1) * this.initialPageSize + 1,
			end:
				(this.initialPageNumber - 1) * this.initialPageSize +
				Math.min(this.initialTotal, this.initialPageSize),
			total: this.initialTotal,
			display: this.shouldDisplay,
		}
	},

	created() {
		EventBus.$on(Events.resultsFetched, this.onResultsFetchedEvent)
	},

	methods: {
		onResultsFetchedEvent(event) {
			if (event.group !== this.group) return

			this.start = event.data.start
			this.end = event.data.end
			this.total = event.data.total
			this.display = event.data.display
		},
	},
}
</script>
